import React, { useState, useEffect, useCallback, useRef } from "react";
import * as XLSX from "xlsx";
import "../styles/invoice.css";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const MEMBERSHIP_TIERS = [
  {
    name: "Basic",
    discount: 10,
    minSpend: 0,
    benefits: ["5% Cashback", "Birthday Voucher"],
  },
  {
    name: "Silver",
    discount: 15,
    minSpend: 5000,
    benefits: ["10% Cashback", "Birthday Voucher", "Free Haircut on 5th visit"],
  },
  {
    name: "Gold",
    discount: 20,
    minSpend: 10000,
    benefits: [
      "15% Cashback",
      "Birthday Voucher",
      "Free Facial on 3rd visit",
      "Priority Booking",
    ],
  },
  {
    name: "Platinum",
    discount: 25,
    minSpend: 20000,
    benefits: [
      "20% Cashback",
      "Birthday Voucher",
      "Free Any Service on 5th visit",
      "Priority Booking",
      "Free Home Service",
    ],
  },
  {
    name: "Premium",
    discount: 15,
    minSpend: 0,
    membershipFee: 1000,
    membershipDuration: 2,
    benefits: [
      "15% Discount on all services",
      "Priority Booking",
      "Birthday Voucher",
      "Free Haircut on 5th visit",
      "Free Facial on 3rd visit",
      "2 Years Membership Validity",
    ],
  },
];

const SERVICES_DATA = {
  Women: [
    {
      category: "Hair Cut",
      icon: "✂",
      services: [
        { name: "Front Flick", price: "200" },
        { name: "Boy Cut", price: "400" },
        { name: "Blunt & Bob", price: "500" },
        { name: "Straight & U Cut", price: "550" },
        { name: "Layer Cut", price: "600" },
      ],
    },
    {
      category: "Threading",
      icon: "〰",
      services: [
        { name: "Forehead", price: "10" },
        { name: "Upper Lip", price: "10" },
        { name: "Chin", price: "10" },
        { name: "Side Locks", price: "40" },
        { name: "Eye Brow", price: "50" },
        { name: "Full Face", price: "150" },
      ],
    },
    {
      category: "Waxing",
      icon: "◈",
      services: [
        { name: "Chin", price: "30" },
        { name: "Upper Lip", price: "30" },
        { name: "For Head", price: "60" },
        { name: "Side Lock", price: "100" },
        { name: "Under Arms", price: "200" },
        { name: "Full Face", price: "250" },
        { name: "Half Arms", price: "400" },
        { name: "Full Arms", price: "500" },
        { name: "Half Leg", price: "600" },
        { name: "Full Leg", price: "1300" },
        { name: "Full Body", price: "5000" },
      ],
    },
    {
      category: "Hair Color",
      icon: "◎",
      services: [
        { name: "Garnier", price: "1000" },
        { name: "Matrix", price: "1500" },
        { name: "Loreal", price: "2000" },
        { name: "Schwarzkope", price: "1600" },
        { name: "Speedy", price: "1800" },
        { name: "Amonia Free", price: "2000" },
        { name: "Top Speedy", price: "2000" },
      ],
    },
    {
      category: "Facial",
      icon: "✦",
      services: [
        { name: "Basic Facial", price: "700" },
        { name: "Fruit Facial", price: "1000" },
        { name: "Aroma Facial", price: "1200" },
        { name: "Anti Ageing", price: "1500" },
        { name: "Silver Facial", price: "1600" },
        { name: "Ordinary Gold", price: "1700" },
        { name: "Ordinary Pearl", price: "1800" },
        { name: "Tan Removal", price: "1800" },
        { name: "Skin Whitening", price: "1900" },
        { name: "Oxy Vitalife", price: "2000" },
        { name: "Diamond", price: "2100" },
        { name: "Hydra Facial", price: "3700" },
      ],
    },
    {
      category: "Bleach & D-Tan",
      icon: "◇",
      services: [
        { name: "Under Arms", price: "150" },
        { name: "Neck", price: "200" },
        { name: "Face", price: "350" },
        { name: "Foot", price: "400" },
        { name: "Half Hand", price: "500" },
        { name: "Half Leg", price: "600" },
        { name: "Full Hand", price: "900" },
        { name: "Full Leg", price: "1300" },
        { name: "Full Body", price: "4500" },
      ],
    },
    {
      category: "Hair Highlighting",
      icon: "✧",
      services: [
        { name: "One Strip", price: "300" },
        { name: "Highlight", price: "1500" },
        { name: "Global Colour", price: "2000" },
      ],
    },
    {
      category: "Body",
      icon: "◉",
      services: [
        { name: "Ear Lobe Piercing", price: "0" },
        { name: "Wart Removal", price: "0" },
        { name: "Tattoos", price: "0" },
        { name: "Body Piercing", price: "0" },
      ],
    },
    {
      category: "Massage",
      icon: "⊕",
      services: [
        { name: "Face Massage", price: "350" },
        { name: "Head Massage", price: "400" },
      ],
    },
    {
      category: "Cleanup",
      icon: "❋",
      services: [
        { name: "Normal Cleanup", price: "450" },
        { name: "Fruit Cleanup", price: "550" },
        { name: "Aroma Cleanup", price: "700" },
        { name: "Silver Cleanup", price: "800" },
        { name: "Gold Cleanup", price: "900" },
        { name: "Pearl Cleanup", price: "1100" },
        { name: "Diamond Cleanup", price: "1300" },
        { name: "Hydra Cleanup", price: "1800" },
      ],
    },
    {
      category: "Hair Spa",
      icon: "◌",
      services: [
        { name: "Normal Spa", price: "1000" },
        { name: "Black Spa", price: "1100" },
        { name: "Repair Spa", price: "1000" },
        { name: "Colour Care Spa", price: "1000" },
        { name: "Smoothening Spa", price: "1100" },
        { name: "Dandruff Spa", price: "1300" },
        { name: "Keratin Spa", price: "1600" },
        { name: "Nano Plasta Spa", price: "1900" },
      ],
    },
    {
      category: "Shahanaz",
      icon: "⊛",
      services: [
        { name: "Veg Peel", price: "1000" },
        { name: "Shahanaz Normal", price: "1700" },
        { name: "Shahanaz Pearl", price: "2500" },
        { name: "Shahanaz Gold", price: "2800" },
        { name: "Shahanaz Diamond", price: "3000" },
      ],
    },
    {
      category: "Henna",
      icon: "❀",
      services: [
        { name: "Natural Henna", price: "800" },
        { name: "Colour Henna", price: "750" },
        { name: "Black Henna", price: "700" },
      ],
    },
    {
      category: "Manicure",
      icon: "◈",
      services: [
        { name: "Normal Manicure", price: "600" },
        { name: "Spa Manicure", price: "800" },
        { name: "Aroma Manicure", price: "1000" },
        { name: "Bloom Manicure", price: "1200" },
        { name: "K&Q SPL Manicure", price: "1500" },
      ],
    },
    {
      category: "Pedicure",
      icon: "◈",
      services: [
        { name: "Normal Pedicure", price: "1000" },
        { name: "Spa Pedicure", price: "1500" },
        { name: "Aroma Pedicure", price: "1700" },
        { name: "Bloom Pedicure", price: "1900" },
        { name: "K&Q SPL Pedicure", price: "2100" },
      ],
    },
    {
      category: "Hair Treatment",
      icon: "✦",
      services: [
        { name: "Blow Dry", price: "450" },
        { name: "Ironing", price: "800" },
        { name: "Rebonding", price: "3000" },
        { name: "Smoothening", price: "5000" },
        { name: "Straightening", price: "4500" },
        { name: "Permanent Blow Dry", price: "5000" },
        { name: "Keratin Treatment", price: "6000" },
        { name: "Nano Plasta", price: "7000" },
      ],
    },
    {
      category: "K&Q Special",
      icon: "★",
      services: [{ name: "Hydra Facial Special", price: "3700" }],
    },
  ],
  Men: [
    {
      category: "Hair Cut",
      icon: "✂",
      services: [
        { name: "Kids Haircut", price: "150" },
        { name: "Gents Haircut", price: "180" },
        { name: "Beard Trimming", price: "150" },
        { name: "Shaving", price: "120" },
        { name: "Change Of Hairstyle", price: "300" },
      ],
    },
    {
      category: "Henna",
      icon: "❀",
      services: [
        { name: "Black Henna Men", price: "400" },
        { name: "Colour Henna Men", price: "450" },
        { name: "Natural Henna Men", price: "500" },
      ],
    },
    {
      category: "Clean Up",
      icon: "❋",
      services: [
        { name: "Normal Clean Up", price: "450" },
        { name: "Fruit Clean Up", price: "550" },
        { name: "Aroma Clean Up", price: "650" },
        { name: "Silver Clean Up", price: "750" },
        { name: "Gold Clean Up", price: "850" },
      ],
    },
    {
      category: "Massage",
      icon: "⊕",
      services: [
        { name: "Face Massage Men", price: "350" },
        { name: "Head Massage Men", price: "350" },
      ],
    },
    {
      category: "Facial",
      icon: "✦",
      services: [
        { name: "Basic Facial Men", price: "800" },
        { name: "Fruit Facial Men", price: "1000" },
        { name: "Aroma Facial Men", price: "1200" },
        { name: "Anti Ageing Men", price: "1400" },
        { name: "Silver Facial Men", price: "1500" },
        { name: "Ordinary Gold Men", price: "1600" },
        { name: "Ordinary Pearl Men", price: "1700" },
        { name: "Tan Removal Men", price: "1700" },
        { name: "Skin Whitening Men", price: "1800" },
        { name: "Oxy Vitalife Men", price: "1900" },
        { name: "Diamond Men", price: "2000" },
        { name: "Hydra Facial Men", price: "3500" },
      ],
    },
    {
      category: "Hair Spa",
      icon: "◌",
      services: [
        { name: "Normal Spa Men", price: "1000" },
        { name: "Black Spa Men", price: "1100" },
        { name: "Repair Spa Men", price: "1000" },
        { name: "Colour Care Spa Men", price: "1000" },
        { name: "Smoothening Spa Men", price: "1100" },
        { name: "Dandruff Spa Men", price: "1300" },
        { name: "Keratin Spa Men", price: "1600" },
        { name: "Nano Plasta Spa Men", price: "1900" },
      ],
    },
    {
      category: "Bleach & D-Tan",
      icon: "◇",
      services: [
        { name: "Face D-Tan Men", price: "400" },
        { name: "Foot D-Tan Men", price: "450" },
        { name: "Half Hand D-Tan Men", price: "550" },
        { name: "Half Leg D-Tan Men", price: "650" },
        { name: "Full Hand D-Tan Men", price: "950" },
      ],
    },
    {
      category: "Shahanaz",
      icon: "⊛",
      services: [
        { name: "Veg Peel Men", price: "900" },
        { name: "Shahanaz Normal Men", price: "1600" },
        { name: "Shahanaz Pearl Men", price: "2400" },
        { name: "Shahanaz Gold Men", price: "2700" },
        { name: "Shahanaz Diamond Men", price: "2900" },
      ],
    },
    {
      category: "Body",
      icon: "◉",
      services: [
        { name: "Ear Lobe Piercing Men", price: "0" },
        { name: "Wart Removal Men", price: "0" },
        { name: "Tattoos Men", price: "0" },
        { name: "Body Piercing Men", price: "0" },
      ],
    },
    {
      category: "Manicure",
      icon: "◈",
      services: [
        { name: "Normal Manicure Men", price: "500" },
        { name: "Spa Manicure Men", price: "700" },
        { name: "Aroma Manicure Men", price: "900" },
        { name: "Bloom Manicure Men", price: "1100" },
      ],
    },
    {
      category: "Pedicure",
      icon: "◈",
      services: [
        { name: "Normal Pedicure Men", price: "900" },
        { name: "Spa Pedicure Men", price: "1400" },
        { name: "Aroma Pedicure Men", price: "1600" },
        { name: "Bloom Pedicure Men", price: "1800" },
      ],
    },
    {
      category: "Hair Treatment",
      icon: "✦",
      services: [
        { name: "Blow Dry Men", price: "200" },
        { name: "Ironing Men", price: "400" },
        { name: "Rebonding Men", price: "1600" },
        { name: "Smoothening Men", price: "1800" },
        { name: "Straightening Men", price: "1900" },
        { name: "Permanent Blow Dry Men", price: "2200" },
        { name: "Keratin Treatment Men", price: "2500" },
        { name: "Nano Plasta Men", price: "2800" },
        { name: "Micro Bonding", price: "3000" },
      ],
    },
    {
      category: "Hair Highlighting",
      icon: "✧",
      services: [
        { name: "Garnier Men", price: "450" },
        { name: "Matrix Men", price: "600" },
        { name: "Loreal Men", price: "650" },
        { name: "Schwarzkopp Men", price: "650" },
        { name: "Speedy Men", price: "750" },
        { name: "Amonia Free Men", price: "850" },
      ],
    },
    {
      category: "Groom Touch Up",
      icon: "◎",
      services: [
        { name: "Party Touch Up", price: "1600" },
        { name: "Groom Shaving", price: "1000" },
      ],
    },
    {
      category: "K&Q Special",
      icon: "★",
      services: [{ name: "Hydra Facial Special Men", price: "3500" }],
    },
  ],
};

// Build flat option list with unique keys embedded
const generateServiceOptions = () => {
  const options = [];
  Object.entries(SERVICES_DATA).forEach(([gender, categories]) => {
    categories.forEach((cat) => {
      cat.services.forEach((srv) => {
        const price = parseFloat(srv.price);
        const label =
          price > 0
            ? `${gender} - ${cat.category} - ${srv.name} - ₹${price}`
            : `${gender} - ${cat.category} - ${srv.name} (On Consultation)`;
        // value encodes full key so we can look up price precisely
        const value = `${gender}||${cat.category}||${srv.name}`;
        options.push({ label, value, price: price || 0 });
      });
    });
  });
  return options;
};
const ALL_SERVICE_OPTIONS = generateServiceOptions();

// ─────────────────────────────────────────────
// MULTI-SELECT DROPDOWN COMPONENT
// ─────────────────────────────────────────────
const MultiSelectDropdown = ({
  options,
  selectedValues,
  onChange,
  placeholder,
  onServiceChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Filter options based on search term
  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group options by gender for better organization
  const getGroupedOptions = () => {
    const grouped = {};
    filteredOptions.forEach((opt) => {
      const gender = opt.label.split(" - ")[0];
      if (!grouped[gender]) grouped[gender] = [];
      grouped[gender].push(opt);
    });
    return grouped;
  };

  const toggleOption = (option) => {
    const isSelected = selectedValues.some((v) => v.value === option.value);
    let newSelected;
    if (isSelected) {
      newSelected = selectedValues.filter((v) => v.value !== option.value);
    } else {
      newSelected = [...selectedValues, option];
    }
    onChange(newSelected);

    // Call onServiceChange with the first selected service for backward compatibility
    if (onServiceChange) {
      onServiceChange(newSelected.length > 0 ? newSelected[0].value : "");
    }
  };

  const removeOption = (optionValue) => {
    const newSelected = selectedValues.filter((v) => v.value !== optionValue);
    onChange(newSelected);
    if (onServiceChange) {
      onServiceChange(newSelected.length > 0 ? newSelected[0].value : "");
    }
  };

  const clearAll = () => {
    onChange([]);
    if (onServiceChange) {
      onServiceChange("");
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const groupedOptions = getGroupedOptions();
  const hasResults = Object.keys(groupedOptions).length > 0;

  // Calculate total price of selected services
  const totalSelectedPrice = selectedValues.reduce(
    (sum, opt) => sum + opt.price,
    0
  );

  return (
    <div className="kq-multiselect-wrap" ref={dropdownRef}>
      <div
        className={`kq-multiselect-trigger ${
          selectedValues.length > 0 ? "kq-has-value" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="kq-multiselect-tags">
          {selectedValues.length === 0 ? (
            <span className="kq-multiselect-placeholder">
              {placeholder || "Select services..."}
            </span>
          ) : (
            selectedValues.map((opt, idx) => (
              <span key={idx} className="kq-multiselect-tag">
                {opt.label.length > 30
                  ? opt.label.substring(0, 30) + "..."
                  : opt.label}
                <button
                  type="button"
                  className="kq-multiselect-tag-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeOption(opt.value);
                  }}
                >
                  ✕
                </button>
              </span>
            ))
          )}
        </div>
        <div className="kq-multiselect-icons">
          {selectedValues.length > 0 && (
            <span
              className="kq-multiselect-clear-icon"
              onClick={(e) => {
                e.stopPropagation();
                clearAll();
              }}
            >
              ✕
            </span>
          )}
          <span
            className="kq-multiselect-arrow"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>
      </div>

      {isOpen && (
        <div className="kq-multiselect-dropdownin">
          {/* Search Bar */}
          <div className="kq-multiselect-search">
            <input
              type="text"
              placeholder="Search services..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
            {searchTerm && (
              <button
                className="kq-search-clear"
                onClick={() => setSearchTerm("")}
              >
                ✕
              </button>
            )}
          </div>

          {/* Results count */}
          {searchTerm && (
            <div className="kq-search-results-count">
              Found {filteredOptions.length} result
              {filteredOptions.length !== 1 ? "s" : ""}
            </div>
          )}

          {/* Options list with grouping */}
          <div className="kq-multiselect-options">
            {!hasResults ? (
              <div className="kq-multiselect-no-results">No services found</div>
            ) : (
              Object.entries(groupedOptions).map(([gender, opts]) => (
                <div key={gender} className="kq-multiselect-group">
                  <div className="kq-multiselect-group-header">
                    <span className="kq-group-icon">
                      {gender === "Women" ? "👩" : "👨"}
                    </span>
                    <span>{gender}</span>
                    <span className="kq-group-count">({opts.length})</span>
                  </div>
                  <div className="kq-multiselect-group-options">
                    {opts.map((opt, idx) => (
                      <label key={idx} className="kq-multiselect-option">
                        <input
                          type="checkbox"
                          checked={selectedValues.some(
                            (v) => v.value === opt.value
                          )}
                          onChange={() => toggleOption(opt)}
                        />
                        <span>{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Footer with actions */}
          <div className="kq-multiselect-footer">
            <div className="kq-multiselect-footer-left">
              {selectedValues.length > 0 && (
                <span className="kq-selected-count">
                  {selectedValues.length} selected | Total: ₹
                  {totalSelectedPrice}
                </span>
              )}
            </div>
            <div className="kq-multiselect-footer-right">
              {selectedValues.length > 0 && (
                <button
                  type="button"
                  className="kq-multiselect-clear"
                  onClick={clearAll}
                >
                  Clear all
                </button>
              )}
              <button
                type="button"
                className="kq-multiselect-done"
                onClick={() => setIsOpen(false)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Determine which staff specialisation a service needs
const getRequiredSpecialisation = (serviceValue) => {
  if (!serviceValue) return null;
  const lower = serviceValue.toLowerCase();
  if (lower.includes("hair cut") || lower.includes("haircut")) return "Haircut";
  if (lower.includes("facial")) return "Facial";
  // Default: show all available staff
  return "All";
};

// Derive membership tier from total spend
const getTierFromSpend = (totalSpend) => {
  if (totalSpend >= 20000) return MEMBERSHIP_TIERS[3]; // Platinum
  if (totalSpend >= 10000) return MEMBERSHIP_TIERS[2]; // Gold
  if (totalSpend >= 5000) return MEMBERSHIP_TIERS[1]; // Silver
  return MEMBERSHIP_TIERS[0]; // Basic
};

// ─────────────────────────────────────────────
// StaffManagement - Updated to use API
// ─────────────────────────────────────────────
const StaffManagement = ({
  onStaffSelect,
  selectedStaff,
  onStaffListUpdate,
}) => {
  const [staffList, setStaffList] = useState([]);
  const [showStaffConfig, setShowStaffConfig] = useState(false);
  const [newStaffName, setNewStaffName] = useState("");
  const [newStaffService, setNewStaffService] = useState("Haircut");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Fetch staff list from API on component mount
  const fetchStaffList = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://salon.mpdatahub.com/api/staff-list"
      );
      const data = await response.json();
      console.log("Staff list from API:", data);

      if (data.success) {
        // Transform API data to match expected format with available flag
        const formattedStaff = data.data.map((staff) => ({
          id: staff.id,
          name: staff.name,
          service: staff.services || staff.service || "All",
          available: true, // Default to available, you can add an available field to API if needed
        }));
        setStaffList(formattedStaff);
        onStaffListUpdate(formattedStaff); // Notify parent component
      } else {
        console.error("Failed to fetch staff:", data);
        alert("Failed to load staff list. Please refresh the page.");
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      alert(
        "Error connecting to server. Please check your internet connection."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const addStaff = async () => {
    const trimmed = newStaffName.trim();
    if (!trimmed) {
      alert("Please enter staff name");
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(
        "https://salon.mpdatahub.com/api/staff-store",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: trimmed,
            services: newStaffService,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          alert("Staff member added successfully!");
          await fetchStaffList(); // Refresh the list
          setNewStaffName("");
          setNewStaffService("Haircut");
        } else {
          alert(data.message || "Failed to add staff member");
        }
      } else if (response.status === 404) {
        alert("Staff store endpoint not found. Please contact administrator.");
        console.error("API endpoint /api/staff-store returned 404");
      } else {
        alert("Failed to add staff member. Please try again.");
      }
    } catch (error) {
      console.error("Error adding staff:", error);
      alert("Error connecting to server. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  const removeStaff = async (staffId) => {
    if (!window.confirm("Are you sure you want to remove this staff member?"))
      return;

    try {
      // Note: You'll need a delete endpoint for this to work
      // For now, we'll just remove from local state after confirming with the API
      const response = await fetch(
        `https://salon.mpdatahub.com/api/delete/${staffId}`,
        {
          method: "GET",
        }
      );

      if (response.ok || response.status === 404) {
        // If delete endpoint exists and works, refresh list
        // If it doesn't exist (404), we'll just refresh the list from server
        await fetchStaffList();
        if (selectedStaff === staffId) onStaffSelect("");
      } else {
        alert("Failed to remove staff member");
      }
    } catch (error) {
      console.error("Error removing staff:", error);
      // Fallback: remove from local state only
      setStaffList((prev) => prev.filter((s) => s.id !== staffId));
      if (selectedStaff === staffId) onStaffSelect("");
      alert("Staff removed locally. Changes may not be saved to server.");
    }
  };

  const toggleAvailability = async (staffId) => {
    // Note: You'll need an update endpoint for this to persist
    // For now, we'll update locally and show a message
    setStaffList((prev) =>
      prev.map((s) =>
        s.id === staffId ? { ...s, available: !s.available } : s
      )
    );

    // Also update parent component
    const updatedStaff = staffList.map((s) =>
      s.id === staffId ? { ...s, available: !s.available } : s
    );
    onStaffListUpdate(updatedStaff);

    // Attempt to update on server if endpoint exists
    try {
      const staff = staffList.find((s) => s.id === staffId);
      const response = await fetch(
        `https://salon.mpdatahub.com/api/staff/${staffId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...staff,
            available: !staff.available,
          }),
        }
      );
      if (!response.ok) {
        console.warn("Failed to update staff availability on server");
      }
    } catch (error) {
      console.warn("Could not update availability on server:", error);
    }
  };

  if (loading) {
    return (
      <div className="staffManagement">
        <button
          type="button"
          className="configToggleBtn staffConfigBtn"
          onClick={() => setShowStaffConfig((v) => !v)}
        >
          {showStaffConfig ? "▼ Hide Staff Management" : "👥 Manage Staff List"}
        </button>
        {showStaffConfig && (
          <div className="configPanel staffConfigPanel">
            <div className="loadingStaff">Loading staff members...</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="staffManagement">
      <button
        type="button"
        className="configToggleBtn staffConfigBtn"
        onClick={() => setShowStaffConfig((v) => !v)}
      >
        {showStaffConfig ? "▼ Hide Staff Management" : "👥 Manage Staff List"}
      </button>

      {showStaffConfig && (
        <div className="configPanel staffConfigPanel">
          <h4>Staff Management</h4>

          <div className="addStaffForm">
            <h5>Add New Staff Member</h5>
            <div className="formGroup">
              <input
                type="text"
                placeholder="Staff Name"
                value={newStaffName}
                onChange={(e) => setNewStaffName(e.target.value)}
                className="staffNameInput"
                disabled={submitting}
              />
              <select
                value={newStaffService}
                onChange={(e) => setNewStaffService(e.target.value)}
                className="staffServiceSelect"
                disabled={submitting}
              >
                <option value="unixes">unixes cutter</option>
                <option value="gents">gents cutter</option>
                <option value="All">General / All Services</option>
              </select>
              <button
                type="button"
                onClick={addStaff}
                className="addStaffBtn"
                disabled={submitting}
              >
                {submitting ? "Adding..." : "+ Add Staff"}
              </button>
            </div>
          </div>

          <div className="staffList">
            <h5>Current Staff Members ({staffList.length})</h5>
            {staffList.length === 0 ? (
              <p className="noStaff">No staff members. Please add some.</p>
            ) : (
              <div className="staffGrid">
                {staffList.map((staff) => (
                  <div
                    key={staff.id}
                    className={`staffCard ${
                      !staff.available ? "inactive" : ""
                    }`}
                  >
                    <div className="staffInfo">
                      <strong>{staff.name}</strong>
                      <span className="staffService">
                        {staff.service} Specialist
                      </span>
                      <span
                        className={`staffStatus ${
                          staff.available ? "available" : "unavailable"
                        }`}
                      >
                        {staff.available ? "✓ Available" : "✗ Unavailable"}
                      </span>
                    </div>
                    <div className="staffActions">
                      {/*  <button
                                                type="button"
                                                className={`toggleStatusBtn ${staff.available ? "makeUnavailable" : "makeAvailable"}`}
                                                onClick={() => toggleAvailability(staff.id)}
                                            >
                                                {staff.available ? "Mark Unavailable" : "Mark Available"}
                                            </button>  */}
                      <button
                        type="button"
                        className="removeStaffBtn"
                        onClick={() => removeStaff(staff.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────
// MembershipConfig (admin panel)
// ─────────────────────────────────────────────
const MembershipConfig = ({ onConfigChange }) => {
  const [tiers, setTiers] = useState(
    MEMBERSHIP_TIERS.map((t) => ({ ...t, benefits: [...t.benefits] }))
  );
  const [selectedTierName, setSelectedTierName] = useState("Basic");
  const [showConfig, setShowConfig] = useState(false);
  const [newBenefit, setNewBenefit] = useState("");

  const currentTier = tiers.find((t) => t.name === selectedTierName);

  const notify = (updatedTiers, tierName) => {
    const tier = updatedTiers.find((t) => t.name === tierName);
    if (tier && onConfigChange) {
      onConfigChange({
        tier: tier.name,
        discount: tier.discount,
        benefits: tier.benefits,
      });
    }
  };

  const handleTierChange = (name) => {
    setSelectedTierName(name);
    notify(tiers, name);
  };

  const handleDiscountChange = (val) => {
    const discount = Math.min(50, Math.max(0, parseInt(val) || 0));
    const updated = tiers.map((t) =>
      t.name === selectedTierName ? { ...t, discount } : t
    );
    setTiers(updated);
    notify(updated, selectedTierName);
  };

  const addBenefit = () => {
    const trimmed = newBenefit.trim();
    if (!trimmed) return;
    const updated = tiers.map((t) =>
      t.name === selectedTierName
        ? { ...t, benefits: [...t.benefits, trimmed] }
        : t
    );
    setTiers(updated);
    setNewBenefit("");
    notify(updated, selectedTierName);
  };

  const removeBenefit = (benefit) => {
    const updated = tiers.map((t) =>
      t.name === selectedTierName
        ? { ...t, benefits: t.benefits.filter((b) => b !== benefit) }
        : t
    );
    setTiers(updated);
    notify(updated, selectedTierName);
  };

  return (
    <div className="membershipConfig">
      <button
        type="button"
        className="configToggleBtn"
        onClick={() => setShowConfig((v) => !v)}
      >
        {showConfig
          ? "▼ Hide Membership Settings"
          : "▶ Admin: Configure Membership"}
      </button>

      {showConfig && currentTier && (
        <div className="configPanel">
          <h4>Membership Configuration</h4>

          <div className="tierSelector">
            <label>Select Tier:</label>
            <select
              value={selectedTierName}
              onChange={(e) => handleTierChange(e.target.value)}
            >
              {tiers.map((t) => (
                <option key={t.id} value={t.name}>
                  {t.name} ({t.discount}% off) —{" "}
                  {t.membershipFee
                    ? `₹${t.membershipFee} (${t.membershipDuration} years)`
                    : `Min ₹${t.minSpend}`}
                </option>
              ))}
            </select>
          </div>

          <div className="discountConfig">
            <label>Discount: {currentTier.discount}%</label>
            <input
              type="range"
              min="0"
              max="50"
              value={currentTier.discount}
              onChange={(e) => handleDiscountChange(e.target.value)}
            />
            <input
              type="number"
              value={currentTier.discount}
              onChange={(e) => handleDiscountChange(e.target.value)}
              min="0"
              max="50"
              className="discountInput"
            />
          </div>

          <div className="benefitsManager">
            <label>Benefits for {selectedTierName}:</label>
            <div className="benefitsList">
              {currentTier.benefits.map((b, idx) => (
                <div key={idx} className="benefitItem">
                  <span>✓ {b}</span>
                  <button
                    type="button"
                    className="removeBenefitBtn"
                    onClick={() => removeBenefit(b)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
            <div className="addBenefit">
              <input
                type="text"
                placeholder="Add new benefit"
                value={newBenefit}
                onChange={(e) => setNewBenefit(e.target.value)}
                onKeyDown={(e) =>
                  e.key === "Enter" && (e.preventDefault(), addBenefit())
                }
              />
              <button type="button" onClick={addBenefit}>
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────
// MembershipRegistrationModal
// ─────────────────────────────────────────────
const MembershipRegistrationModal = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    dob: "",
    preferredTier: "Basic",
    referralCode: "",
    agreeToTerms: false,
    paymentConfirmed: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    if (!formData.name.trim()) {
      alert("Please enter customer name");
      return false;
    }
    if (!/^\d{10}$/.test(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return false;
    }
    if (!formData.agreeToTerms) {
      alert("Please agree to the terms and conditions");
      return false;
    }
    if (formData.preferredTier === "Premium" && !formData.paymentConfirmed) {
      alert("Please confirm payment of ₹1000 for Premium membership");
      return false;
    }
    return true;
  };

  const handleProceedToPayment = () => {
    if (!formData.agreeToTerms) {
      alert("Please agree to the terms and conditions");
      return;
    }
    setShowPaymentModal(true);
  };

  const handlePaymentConfirmation = () => {
    setFormData((prev) => ({ ...prev, paymentConfirmed: true }));
    setShowPaymentModal(false);
    // Auto-submit after payment confirmation
    setTimeout(() => {
      const fakeEvent = { preventDefault: () => {} };
      handleSubmit(fakeEvent);
    }, 100);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const selectedTier = MEMBERSHIP_TIERS.find(
        (t) => t.name === formData.preferredTier
      );

      const payload = {
        ...formData,
        registrationDate: new Date().toISOString(),
        membershipStatus: "active",
        points: 0,
        totalSpend: 0,
        visitCount: 0,
        membershipFee: selectedTier.membershipFee || 0,
        membershipDuration: selectedTier.membershipDuration || null,
        membershipExpiry: selectedTier.membershipDuration
          ? new Date(
              Date.now() +
                selectedTier.membershipDuration * 365 * 24 * 60 * 60 * 1000
            ).toISOString()
          : null,
      };

      const response = await fetch(
        "https://salon.mpdatahub.com/api/register-membership",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (!data.success) throw new Error(data.message || "Registration failed");

      const tier = MEMBERSHIP_TIERS.find(
        (t) => t.name === formData.preferredTier
      );

      let successMessage = `✅ Membership registered!\nWelcome ${formData.name} — ${formData.preferredTier} member with ${tier.discount}% discount.`;
      if (tier.membershipFee) {
        successMessage += `\n💰 Membership Fee: ₹${tier.membershipFee}\n📅 Valid for: ${tier.membershipDuration} years`;
      }
      alert(successMessage);

      let message =
        `Hi ${formData.name.toUpperCase()},\n\n` +
        `🎉 Welcome to King & Queen Unisex Family Salon & Bridal Studio!\n\n` +
        `✨ Your ${formData.preferredTier} Membership is now active!\n\n` +
        `📋 Membership Details:\n` +
        `• Tier: ${formData.preferredTier}\n` +
        `• Discount: ${tier.discount}% off on all services\n`;

      if (tier.membershipFee) {
        message +=
          `• Membership Fee: ₹${tier.membershipFee}\n` +
          `• Validity: ${tier.membershipDuration} years\n`;
      }

      message +=
        `• Benefits:\n${tier.benefits.map((b) => `  ✓ ${b}`).join("\n")}\n\n` +
        `📱 Mobile: ${formData.mobile}\n\n` +
        `Start enjoying your benefits today! 💇‍♀️💇‍♂️\n\n` +
        `Sincerely,\nKing & Queen Unisex Family Salon & Bridal Studio`;

      window.open(
        `https://wa.me/91${formData.mobile}?text=${encodeURIComponent(
          message
        )}`,
        "_blank"
      );

      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Registration error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectedTierDetails = MEMBERSHIP_TIERS.find(
    (t) => t.name === formData.preferredTier
  );

  return (
    <div className="membershipModal">
      <div className="modalOverlay" onClick={onClose} />
      <div className="modalContainer">
        <div className="modalHeader">
          <h2>✨ Membership Registration ✨</h2>
          <button className="closeModalBtn" onClick={onClose}>
            ×
          </button>
        </div>

        {!showPaymentModal ? (
          <form onSubmit={handleSubmit} className="membershipForm">
            <div className="formSection">
              <h3>Personal Information</h3>
              <div className="formField">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Customer name"
                  required
                />
              </div>
              <div className="formField">
                <label>Mobile Number *</label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="10-digit mobile"
                  pattern="[0-9]{10}"
                  required
                />
              </div>
              <div className="formField">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email (optional)"
                />
              </div>
              <div className="formField">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                />
              </div>
              <div className="formField">
                <label>Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Address (optional)"
                  rows="3"
                />
              </div>
            </div>

            <div className="formSection">
              <h3>Membership Selection</h3>
              <div className="formField">
                <label>Select Tier *</label>
                <select
                  name="preferredTier"
                  value={formData.preferredTier}
                  onChange={handleChange}
                >
                  {MEMBERSHIP_TIERS.map((t) => (
                    <option key={t.name} value={t.name}>
                      {t.name} — {t.discount}% Discount{" "}
                      {t.membershipFee
                        ? `(₹${t.membershipFee} - ${t.membershipDuration} years)`
                        : `(Min. Spend: ₹${t.minSpend})`}
                    </option>
                  ))}
                </select>
              </div>
              {selectedTierDetails && (
                <div className="benefitsPreview">
                  <strong>✨ Benefits Included:</strong>
                  <ul>
                    {selectedTierDetails.benefits.map((b, i) => (
                      <li key={i}>✓ {b}</li>
                    ))}
                  </ul>
                  {selectedTierDetails.membershipFee && (
                    <div className="membershipFeeInfo">
                      💰{" "}
                      <strong>
                        Membership Fee: ₹{selectedTierDetails.membershipFee}
                      </strong>
                      <br />
                      📅 Valid for: {
                        selectedTierDetails.membershipDuration
                      }{" "}
                      years
                    </div>
                  )}
                </div>
              )}
              <div className="formField">
                <label>Referral Code (optional)</label>
                <input
                  type="text"
                  name="referralCode"
                  value={formData.referralCode}
                  onChange={handleChange}
                  placeholder="Referral code"
                />
              </div>
            </div>

            <div className="formSection">
              <div className="formField checkboxField">
                <label>
                  <input
                    type="checkbox"
                    name="agreeToTerms"
                    checked={formData.agreeToTerms}
                    onChange={handleChange}
                  />{" "}
                  I agree to the membership terms and conditions *
                </label>
              </div>
              <small className="termsNote">
                By registering, you agree to receive updates and offers from
                King & Queen Salon.
              </small>
            </div>

            {formData.preferredTier === "Premium" ? (
              <button
                type="button"
                className="submitBtn"
                onClick={handleProceedToPayment}
              >
                Proceed to Payment (₹1000)
              </button>
            ) : (
              <button
                type="submit"
                className="submitBtn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Registering…" : "Register Membership"}
              </button>
            )}
          </form>
        ) : (
          <div className="paymentModal">
            <h3>💳 Premium Membership Payment</h3>
            <div className="paymentDetails">
              <p>
                <strong>Membership Tier:</strong> Premium
              </p>
              <p>
                <strong>Membership Fee:</strong> ₹1000
              </p>
              <p>
                <strong>Validity:</strong> 2 Years
              </p>
              <p>
                <strong>Discount:</strong> 15% off on all services
              </p>
            </div>
            <div className="paymentInstructions">
              <h4>Payment Instructions:</h4>
              <p>Please pay ₹1000 via:</p>
              <ul>
                <li>📱 UPI: salon@payment (Scan QR code)</li>
                <li>💳 Card: At the salon counter</li>
                <li>💰 Cash: At the salon counter</li>
              </ul>
              <p className="paymentNote">
                After payment, click "Confirm Payment" to complete registration.
              </p>
            </div>
            <div className="paymentActions">
              <button
                className="cancelPaymentBtn"
                onClick={() => setShowPaymentModal(false)}
              >
                Cancel
              </button>
              <button
                className="confirmPaymentBtn"
                onClick={handlePaymentConfirmation}
              >
                Confirm Payment
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// MembershipRegistrationButton
// ─────────────────────────────────────────────
const MembershipRegistrationButton = () => {
  const [show, setShow] = useState(false);
  return (
    <>
      <div className="membershipRegistrationButtonWrapper">
        <button className="newMembershipBtn" onClick={() => setShow(true)}>
          ✨ New Customer? Register for Membership ✨
        </button>
      </div>
      {show && (
        <MembershipRegistrationModal
          onClose={() => setShow(false)}
          onSuccess={() => setShow(false)}
        />
      )}
    </>
  );
};

// ─────────────────────────────────────────────
// InvoiceForm
// ─────────────────────────────────────────────
const InvoiceForm = ({ isRegistered }) => {
  // Customer fields
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  // Customer validation states
  const [customerExists, setCustomerExists] = useState(false);
  const [customerCheckDone, setCustomerCheckDone] = useState(false);

  // Service & pricing - UPDATED FOR MULTI-SELECT
  const [selectedServices, setSelectedServices] = useState([]); // Array of service objects
  const [serviceValue, setServiceValue] = useState(""); // Keep for backward compatibility with staff selection
  const [price, setPrice] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);

  // Membership
  const [isMember, setIsMember] = useState(false);
  const [membershipTier, setMembershipTier] = useState("Basic");
  const [membershipDiscount, setMembershipDiscount] = useState(10);
  const [membershipBenefits, setMembershipBenefits] = useState([]);
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [visitCount, setVisitCount] = useState(0);
  const [redeemPoints, setRedeemPoints] = useState(false);
  const [pointsRedeemed, setPointsRedeemed] = useState(0);

  // Staff
  const [staffList, setStaffList] = useState([]);
  const [availableStaff, setAvailableStaff] = useState([]);
  const [assignedStaffId, setAssignedStaffId] = useState("");
  const [assignedStaffName, setAssignedStaffName] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // Refs to always have fresh values inside callbacks
  const membershipDiscountRef = useRef(membershipDiscount);
  const loyaltyPointsRef = useRef(loyaltyPoints);
  useEffect(() => {
    membershipDiscountRef.current = membershipDiscount;
  }, [membershipDiscount]);
  useEffect(() => {
    loyaltyPointsRef.current = loyaltyPoints;
  }, [loyaltyPoints]);

  // Calculate total price from selected services
  const calculateTotalPrice = (services) => {
    return services.reduce((sum, s) => sum + (s.price || 0), 0);
  };

  // Update price whenever selected services change
  useEffect(() => {
    const totalPrice = calculateTotalPrice(selectedServices);
    setPrice(totalPrice);
    recalculate(
      totalPrice,
      isMember,
      membershipDiscountRef.current,
      loyaltyPointsRef.current,
      redeemPoints
    );
  }, [selectedServices]);

  // Stable callback so StaffManagement doesn't loop
  const handleStaffListUpdate = useCallback((list) => {
    console.log("Staff list updated in InvoiceForm:", list);
    setStaffList(list);
  }, []);

  // Updated fetchCustomerHistory function with 404 handling
  const fetchCustomerHistory = async (mob) => {
    setCustomerCheckDone(false);
    try {
      const res = await fetch(
        `https://salon.mpdatahub.com/api/customer-history?mobile=${mob}`
      );

      // Check if response is 404 - customer not found
      if (res.status === 404) {
        console.log("Customer not found for mobile:", mob);
        setIsMember(false);
        setMembershipTier("Basic");
        setMembershipDiscount(10);
        setMembershipBenefits([]);
        setLoyaltyPoints(0);
        setVisitCount(0);
        setCustomerExists(false);
        setCustomerCheckDone(true);
        return;
      }

      // If response is not OK but also not 404
      if (!res.ok) {
        console.error("API error:", res.status);
        setCustomerExists(false);
        setCustomerCheckDone(true);
        return;
      }

      const data = await res.json();
      const customer = data.data;

      if (data.success && customer) {
        const totalSpend = parseFloat(customer.total_spend) || 0;
        const tier = getTierFromSpend(totalSpend);

        setIsMember(customer.membership_status === "active");
        setVisitCount(customer.visit_count || 0);
        setLoyaltyPoints(customer.points || 0);
        setMembershipTier(customer.preferred_tier || tier.name);
        setMembershipDiscount(tier.discount);
        setMembershipBenefits(tier.benefits);
        setCustomerExists(true);
      } else {
        setIsMember(false);
        setMembershipTier("Basic");
        setMembershipDiscount(10);
        setMembershipBenefits([]);
        setLoyaltyPoints(0);
        setVisitCount(0);
        setCustomerExists(false);
      }
      setCustomerCheckDone(true);
    } catch (err) {
      console.error("Error fetching customer history:", err);
      setIsMember(false);
      setCustomerExists(false);
      setCustomerCheckDone(true);
    }
  };

  // Fetch customer history when 10-digit mobile entered
  useEffect(() => {
    if (/^\d{10}$/.test(mobile)) {
      fetchCustomerHistory(mobile);
    } else {
      setIsMember(false);
      setMembershipTier("Basic");
      setMembershipDiscount(10);
      setLoyaltyPoints(0);
      setVisitCount(0);
      setCustomerExists(false);
      setCustomerCheckDone(true);
    }
  }, [mobile]);

  // Update available staff whenever service or staffList changes
  useEffect(() => {
    if (!serviceValue) {
      setAvailableStaff([]);
      return;
    }
    const required = getRequiredSpecialisation(serviceValue);
    console.log("Required specialisation:", required);
    console.log("All staff list:", staffList);

    const filtered = staffList.filter(
      (s) =>
        s.available &&
        (required === "All" || s.service === required || s.service === "All")
    );
    console.log("Filtered available staff:", filtered);
    setAvailableStaff(filtered);

    // Deselect staff if no longer available
    if (assignedStaffId && !filtered.some((s) => s.id === assignedStaffId)) {
      setAssignedStaffId("");
      setAssignedStaffName("");
    }
  }, [serviceValue, staffList]);

  // Central price calculator — accepts explicit params to avoid stale closures
  const recalculate = (basePrice, member, discount, points, redeem) => {
    const discountAmt = member ? basePrice * (discount / 100) : 0;
    const priceAfterDiscount = basePrice - discountAmt;
    let redeemed = 0;
    if (redeem && points >= 100) {
      redeemed = Math.min(points, priceAfterDiscount);
    }
    setPointsRedeemed(redeemed);
    setFinalPrice(Math.max(0, priceAfterDiscount - redeemed));
  };

  const handleServiceChange = (val) => {
    setServiceValue(val);
    // Note: price is now calculated from selectedServices array
    setAssignedStaffId("");
    setAssignedStaffName("");
  };

  // Handle multi-select service change
  const handleMultiServiceChange = (services) => {
    setSelectedServices(services);
    // Update serviceValue to the first selected service for staff specialization
    if (services.length > 0) {
      setServiceValue(services[0].value);
    } else {
      setServiceValue("");
    }
  };

  const handleMembershipToggle = (checked) => {
    setIsMember(checked);
    if (!checked) {
      setMembershipTier("");
      setMembershipBenefits([]);
    }
    recalculate(
      price,
      checked,
      membershipDiscountRef.current,
      loyaltyPointsRef.current,
      redeemPoints
    );
  };

  const handleMembershipConfigChange = (config) => {
    setMembershipTier(config.tier);
    setMembershipDiscount(config.discount);
    setMembershipBenefits(config.benefits);
    membershipDiscountRef.current = config.discount;
    recalculate(
      price,
      isMember,
      config.discount,
      loyaltyPointsRef.current,
      redeemPoints
    );
  };

  const handleRedeemToggle = (checked) => {
    setRedeemPoints(checked);
    recalculate(
      price,
      isMember,
      membershipDiscountRef.current,
      loyaltyPointsRef.current,
      checked
    );
  };

  const handleStaffSelect = (staffId) => {
    const id = Number(staffId);
    const staff = staffList.find((s) => s.id === id);
    if (staff) {
      setAssignedStaffId(id);
      setAssignedStaffName(staff.name);
      console.log("Staff selected:", staff.name);
    }
  };

  const resetForm = () => {
    setName("");
    setMobile("");
    setSelectedServices([]);
    setServiceValue("");
    setPrice(0);
    setIsMember(false);
    setMembershipTier("Basic");
    setMembershipDiscount(10);
    setMembershipBenefits([]);
    setFinalPrice(0);
    setAssignedStaffId("");
    setAssignedStaffName("");
    setRedeemPoints(false);
    setPointsRedeemed(0);
    setLoyaltyPoints(0);
    setVisitCount(0);
    setCustomerExists(false);
    setCustomerCheckDone(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // For registered customer form, validate that customer exists
    if (isRegistered) {
      if (!customerCheckDone) {
        alert("Please wait while we verify the customer...");
        return;
      }

      if (!customerExists) {
        alert(
          "❌ This mobile number is NOT REGISTERED.\n\nPlease register the customer for membership first or switch to Non-Registered Customer form."
        );
        return;
      }

      if (!/^\d{10}$/.test(mobile)) {
        alert("Please enter a valid 10-digit mobile number");
        return;
      }
    }

    if (selectedServices.length === 0) {
      alert("Please select at least one service");
      return;
    }
    if (!assignedStaffId) {
      alert("Please select a staff member");
      return;
    }

    // Check if any service has zero price (On Consultation)
    const hasZeroPriceService = selectedServices.some((s) => s.price === 0);
    if (hasZeroPriceService) {
      const proceed = window.confirm(
        "One or more services have no fixed price (On Consultation). Proceed?"
      );
      if (!proceed) return;
    }

    setIsLoading(true);
    const pointsEarned = Math.floor(finalPrice * 0.05);

    // Get service display names as comma-separated string
    const serviceNames = selectedServices
      .map((s) => {
        const parts = s.value.split("||");
        return parts.length === 3
          ? `${parts[0]} - ${parts[1]} - ${parts[2]}`
          : s.value;
      })
      .join(", ");

    const serviceValues = selectedServices.map((s) => s.value).join("|||");

    try {
      let data;
      let invoiceUrl = "";

      if (isRegistered) {
        // For registered customers - use submit-Review endpoint
        const payload = {
          name,
          mobile,
          rating: "",
          service: serviceNames,
          serviceValue: serviceValues,
          originalPrice: price,
          discount: isMember ? membershipDiscount : 0,
          discountAmount: isMember ? price * (membershipDiscount / 100) : 0,
          pointsRedeemed,
          pointsEarned,
          finalPrice,
          isMember,
          isRegistered,
          membershipTier,
          membershipBenefits,
          assignedStaff: assignedStaffName,
          assignedStaffId,
          visitCount: visitCount + 1,
          servicesCount: selectedServices.length,
        };

        console.log("Payload for registered submission:", payload);

        const res = await fetch(
          "https://salon.mpdatahub.com/api/submit-Review",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
        data = await res.json();
        invoiceUrl = data.invoice_url || "";
      } else {
        // For non-registered customers - use submit-non-register endpoint
        const payload = {
          name: name,
          mobile: mobile,
          service: serviceNames,
          serviceValue: serviceValues,
          servicesCount: selectedServices.length,
        };

        console.log("Payload for non-registered submission:", payload);
        console.log("Submitting to /api/submit-non-register...");

        const res = await fetch(
          "https://salon.mpdatahub.com/api/submit-non-register",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
        data = await res.json();
        invoiceUrl = data.invoice_url || "";
      }

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      // Format the WhatsApp message as requested
      let message = `Hi ${name.toUpperCase()},\n\n`;

      if (isRegistered) {
        // Registered customer message
        message += `Your appointment at King & Queen Unisex Family Salon & Bridal Studio on ${formattedDate} at ${formattedTime} is Completed.\n\n`;
        message += `Services: ${serviceNames}\n\n`;

        // Add membership discount info if applicable
        if (isMember && membershipDiscount > 0) {
          message += `✨ Membership Benefits Applied: ${membershipDiscount}% discount\n`;
        }

        message += `\nPlease rate us on Google: https://g.page/r/CbyPDOj_Qxu8EAE/review\n\n`;
        message += `Here is your invoice: ${invoiceUrl || ""}\n\n`;
        message += `Sincerely,\nThe team at King & Queen Unisex Family Salon & Bridal Studio`;
      } else {
        // Non-registered customer message
        message += `Your appointment at King & Queen Unisex Family Salon & Bridal Studio on ${formattedDate} at ${formattedTime} is Completed.\n\n`;
        message += `Services: ${serviceNames}\n\n`;
        message += `Please rate us on Google: https://g.page/r/CbyPDOj_Qxu8EAE/review\n\n`;
        message += `Here is your invoice: ${invoiceUrl || ""}\n\n`;
        message += `✨ Become a member and enjoy exclusive benefits including discounts, cashback, and more!\n\n`;
        message += `Sincerely,\nThe team at King & Queen Unisex Family Salon & Bridal Studio`;
      }

      const cleanMobile = mobile.replace(/\D/g, "");
      console.log(cleanMobile);

      const waNumber =
        cleanMobile.length === 10 ? `91${cleanMobile}` : cleanMobile;
      window.open(
        `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`,
        "_blank"
      );
      alert("Opening WhatsApp to send the invoice…");

      resetForm();
    } catch (err) {
      console.error("Submit error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const discountAmount = isMember ? price * (membershipDiscount / 100) : 0;
  const savings = price - finalPrice;

  return (
    <form className="invoiceForm" onSubmit={handleSubmit}>
      <h2 style={{ fontStyle: "italic" }}>
        {isRegistered
          ? "Invoice — Registered Customer"
          : "Invoice — Non-Registered Customer"}
      </h2>

      <StaffManagement
        onStaffSelect={handleStaffSelect}
        selectedStaff={assignedStaffId}
        onStaffListUpdate={handleStaffListUpdate}
      />

      <MembershipConfig onConfigChange={handleMembershipConfigChange} />

      <input
        type="text"
        placeholder="Customer Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <input
        type="tel"
        placeholder="Mobile Number (10 digits)"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
        required
        pattern="[0-9]{10}"
      />

      {/* Customer validation status message */}
      {mobile && /^\d{10}$/.test(mobile) && !customerCheckDone && (
        <div className="checking-status">
          🔍 Checking customer registration...
        </div>
      )}
      {mobile &&
        /^\d{10}$/.test(mobile) &&
        customerCheckDone &&
        !customerExists &&
        isRegistered && (
          <div className="error-status">
            ⚠️ This mobile number is not registered. Please register the
            customer first.
          </div>
        )}
      {mobile &&
        /^\d{10}$/.test(mobile) &&
        customerCheckDone &&
        customerExists &&
        isRegistered && (
          <div className="success-status">
            ✅ Customer verified! {membershipTier} member with{" "}
            {membershipDiscount}% discount.
          </div>
        )}

      {/* SERVICE SELECT - MULTI-SELECT DROPDOWN */}
      <div className="serviceSelectWrapper">
        <label>Select Service(s):</label>
        <MultiSelectDropdown
          options={ALL_SERVICE_OPTIONS}
          selectedValues={selectedServices}
          onChange={handleMultiServiceChange}
          placeholder="Search and select services..."
        />
        {selectedServices.length > 0 && (
          <div className="selectedServicesSummary">
            <strong>Selected Services ({selectedServices.length}):</strong>
            <ul>
              {selectedServices.map((s, idx) => (
                <li key={idx}>
                  {s.label}
                  {s.price > 0 && (
                    <span className="servicePrice"> - ₹{s.price}</span>
                  )}
                </li>
              ))}
            </ul>
            <div className="totalPriceSummary">Total: ₹{price.toFixed(2)}</div>
          </div>
        )}
      </div>

      {/* STAFF SELECTION */}
      {serviceValue && (
        <div className="staffSelection">
          <label>Assign Staff Member:</label>
          <select
            value={assignedStaffId}
            onChange={(e) => handleStaffSelect(e.target.value)}
            required
            className="staffDropdown"
          >
            <option value="">Select Staff</option>
            {availableStaff.map((staff) => (
              <option key={staff.id} value={staff.id}>
                {staff.name} — {staff.service} Specialist
              </option>
            ))}
          </select>
          {availableStaff.length === 0 && (
            <div className="noStaffWarning">
              ⚠️ No available staff for this service. Please add staff in Staff
              Management above.
            </div>
          )}
        </div>
      )}

      {/* MEMBERSHIP */}
      <div className="membershipCheckbox">
        <label>
          <input
            type="checkbox"
            checked={isMember}
            onChange={(e) => handleMembershipToggle(e.target.checked)}
          />{" "}
          Membership Customer
        </label>
        {isMember && membershipTier && (
          <div className="membershipInfo">
            <span className="membershipBadge">{membershipTier} Member</span>
            <span className="discountBadge">{membershipDiscount}% OFF</span>
            {visitCount > 0 && (
              <span className="visitBadge">Visit #{visitCount}</span>
            )}
          </div>
        )}
      </div>

      {isMember && membershipBenefits.length > 0 && (
        <div className="benefitsSection">
          <strong>✨ Membership Benefits:</strong>
          <ul>
            {membershipBenefits.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </div>
      )}

      {/* REDEEM POINTS */}
      {isMember && loyaltyPoints >= 100 && (
        <div className="pointsSection">
          <label>
            <input
              type="checkbox"
              checked={redeemPoints}
              onChange={(e) => handleRedeemToggle(e.target.checked)}
            />{" "}
            Redeem Points — Save ₹
            {Math.min(
              loyaltyPoints,
              Math.max(0, price - discountAmount)
            ).toFixed(2)}
          </label>
          <div className="pointsInfo">Available Points: {loyaltyPoints}</div>
        </div>
      )}

      {/* PRICE BREAKDOWN */}
      {price > 0 && (
        <div className="priceBreakdown">
          <div className="priceRow">
            <span>Total Original Price:</span>
            <span>₹{price.toFixed(2)}</span>
          </div>
          {isMember && (
            <div className="priceRow discountRow">
              <span>
                {membershipTier} Discount ({membershipDiscount}%):
              </span>
              <span>-₹{discountAmount.toFixed(2)}</span>
            </div>
          )}
          {pointsRedeemed > 0 && (
            <div className="priceRow pointsRow">
              <span>Points Redeemed:</span>
              <span>-₹{pointsRedeemed.toFixed(2)}</span>
            </div>
          )}
          <div className="priceRow totalRow">
            <strong>Final Price:</strong>
            <strong>₹{finalPrice.toFixed(2)}</strong>
          </div>
          {savings > 0 && (
            <div className="savingsMessage">
              💰 You saved ₹{savings.toFixed(2)} today!
            </div>
          )}
        </div>
      )}

      {assignedStaffName && (
        <div className="staffInfo">✨ Assigned Staff: {assignedStaffName}</div>
      )}

      <button
        type="submit"
        disabled={
          isLoading || (isRegistered && customerCheckDone && !customerExists)
        }
      >
        {isLoading ? "Sending…" : "Send Invoice via WhatsApp"}
      </button>
    </form>
  );
};

// ─────────────────────────────────────────────
// CustomerHistoryTable
// ─────────────────────────────────────────────
const CustomerHistoryTable = ({ activeTab }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    fetchCustomers();
  }, [activeTab]);

  const fetchCustomers = async () => {
    setLoading(true);
    setError(null);
    const urlMap = {
      registered: "https://salon.mpdatahub.com/api/register-users",
      "non-registered": "https://salon.mpdatahub.com/api/non-register-users",
      all: "https://salon.mpdatahub.com/api/slots",
    };
    try {
      const res = await fetch(urlMap[activeTab]);
      const data = await res.json();
      if (data.success) setCustomers(data.data);
      else setError("Failed to fetch customers");
    } catch {
      setError("Error loading customer data");
    } finally {
      setLoading(false);
    }
  };

  const fmt = {
    date: (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "N/A"),
    price: (p) => (p != null ? `₹${parseFloat(p).toFixed(2)}` : "N/A"),
    stars: (r) => (r ? "⭐".repeat(parseInt(r)) : "—"),
  };

  // Normalise field names — API may return snake_case or camelCase
  const field = (c, snake, camel) => c[snake] ?? c[camel] ?? null;

  const downloadAsExcel = () => {
    if (!customers.length) {
      alert("No data to download");
      return;
    }
    setDownloading(true);
    try {
      const sheetMap = {
        registered: "Registered_Customers",
        "non-registered": "Non_Registered_Customers",
        all: "All_Customers",
      };
      const excelData = customers.map((c) => ({
        ID: c.id,
        Name: c.name || "N/A",
        ...(activeTab === "registered" && { Email: c.email || "N/A" }),
        Phone: c.phone || c.mobile || "N/A",
        Date: fmt.date(c.date || c.created_at),
        Service: c.service || "N/A",
        ...(activeTab !== "non-registered" && { Slot: c.slot || "Walk-in" }),
        "Original Price": fmt.price(
          field(c, "original_price", "originalPrice")
        ),
        "Discount %": `${c.discount || 0}%`,
        "Discount Amount": fmt.price(
          field(c, "discount_amount", "discountAmount")
        ),
        "Points Redeemed": fmt.price(
          field(c, "points_redeemed", "pointsRedeemed")
        ),
        "Points Earned": field(c, "points_earned", "pointsEarned") ?? 0,
        "Final Price": fmt.price(field(c, "final_price", "finalPrice")),
        Membership: field(c, "preferred_tier", "membershipTier") || "No",
        Staff: field(c, "assigned_staff", "assignedStaff") || "N/A",
        "Visit Count": field(c, "visit_count", "visitCount") ?? 1,
        Rating: c.rating ? `${c.rating} Stars` : "—",
        ...(activeTab === "all" && {
          Token: c.token || "N/A",
          Review: c.review || "—",
        }),
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const colWidths = Object.keys(excelData[0] || {}).map((key) => ({
        wch: Math.min(
          50,
          Math.max(
            key.length,
            ...excelData.map((r) => String(r[key] || "").length)
          ) + 2
        ),
      }));
      ws["!cols"] = colWidths;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetMap[activeTab]);
      XLSX.writeFile(
        wb,
        `${sheetMap[activeTab]}_${new Date().toISOString().split("T")[0]}.xlsx`
      );
    } catch (err) {
      console.error("Excel error:", err);
      alert("Error generating Excel file.");
    } finally {
      setDownloading(false);
    }
  };

  if (loading) return <div className="loading">Loading customer history…</div>;
  if (error) return <div className="error">{error}</div>;
  if (!customers.length)
    return <div className="no-data">No customer records found</div>;

  const titleMap = {
    registered: "Registered Customers History",
    "non-registered": "Non-Registered Customers History",
    all: "All Customers History",
  };

  return (
    <div className="customer-history">
      <div className="history-header-wrapper">
        <h3>{titleMap[activeTab]}</h3>
        <button
          className="download-excel-btn"
          onClick={downloadAsExcel}
          disabled={downloading}
        >
          {downloading ? "Downloading…" : "📊 Download as Excel"}
        </button>
      </div>
      <div className="table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              {activeTab === "registered" && <th>Email</th>}
              <th>Phone</th>
              <th>Date</th>
              <th>Service</th>
              {activeTab !== "non-registered" && <th>Slot</th>}
              <th>Original Price</th>
              <th>Discount</th>
              <th>Final Price</th>
              <th>Membership</th>
              <th>Total spent</th>
              <th>Staff</th>
              <th>Rating</th>
              {activeTab === "all" && <th>Token</th>}
              {activeTab === "all" && <th>Review</th>}
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id}>
                <td>{c.id}</td>
                <td>{c.name || "N/A"}</td>
                {activeTab === "registered" && <td>{c.email || "N/A"}</td>}
                <td>{c.phone || c.mobile || "N/A"}</td>
                <td>{fmt.date(c.date || c.created_at)}</td>
                <td>{c.service || "N/A"}</td>
                {activeTab !== "non-registered" && (
                  <td>{c.slot || "Walk-in"}</td>
                )}
                <td>
                  {fmt.price(field(c, "original_price", "originalPrice"))}
                </td>
                <td>{c.discount ? `${c.discount}` : "0%"}</td>
                <td className="price-cell">
                  {fmt.price(field(c, "final_price", "finalPrice"))}
                </td>
                <td>
                  {field(c, "preferred_tier", "membershipTier") ? (
                    <span
                      className={`membership-badge ${String(
                        field(c, "preferred_tier", "membershipTier")
                      ).toLowerCase()}`}
                    >
                      {field(c, "preferred_tier", "membershipTier")}
                    </span>
                  ) : (
                    "No"
                  )}
                </td>
                <td>{c.total_spend}</td>
                <td>{field(c, "assigned_staff", "assignedStaff") || "N/A"}</td>
                <td className="rating-cell">{fmt.stars(c.rating)}</td>
                {activeTab === "all" && <td>{c.token || "N/A"}</td>}
                {activeTab === "all" && <td>{c.review || "—"}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="record-count">Total Records: {customers.length}</div>
    </div>
  );
};

// ─────────────────────────────────────────────
// Main Invoice Component
// ─────────────────────────────────────────────
const Invoice = () => {
  const [isRegistered, setIsRegistered] = useState(true);
  const [historyTab, setHistoryTab] = useState("registered");

  return (
    <div className="invoiceContainer">
      <div className="formWrapper">
        <MembershipRegistrationButton />

        <div className="buttonContainer">
          <button
            className={`toggleButton ${isRegistered ? "active" : ""}`}
            onClick={() => setIsRegistered(true)}
          >
            Registered Customer Invoice
          </button>
          <button
            className={`toggleButton ${!isRegistered ? "active" : ""}`}
            onClick={() => setIsRegistered(false)}
          >
            Non-Registered Customer Invoice
          </button>
        </div>

        {/* KEY forces full re-mount when switching — clears all form state */}
        <InvoiceForm
          key={isRegistered ? "registered" : "non-registered"}
          isRegistered={isRegistered}
        />
      </div>

      <div className="historySection">
        <div className="historyHeader">
          <h2>Customer History</h2>
          <div className="historyTabs">
            {["registered", "non-registered", "all"].map((tab) => (
              <button
                key={tab}
                className={`historyTab ${historyTab === tab ? "active" : ""}`}
                onClick={() => setHistoryTab(tab)}
              >
                {tab === "registered"
                  ? "Registered"
                  : tab === "non-registered"
                  ? "Non-Registered"
                  : "All Customers"}
              </button>
            ))}
          </div>
        </div>
        <CustomerHistoryTable activeTab={historyTab} />
      </div>
    </div>
  );
};

export default Invoice;
